import { createContextMenuInput } from '@databases/selections';

import { SelectionFeatureKeys, type SelectionInputFeature } from '../../features/types';

export function createContextMenuInputFeature(): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.CONTEXT_MENU_INPUT,
    type: 'input',
    // Always active — context menu input captures right-click events
    // to trigger cell selection before the context menu effect shows.
    factory: (machine) => createContextMenuInput(machine),
  };
}
